// extracted by mini-css-extract-plugin
export default {"SummerChallengeSection":"styles_SummerChallengeSection__z8I3i","image":"styles_image__pIZ5a"};